import { SVGProps } from 'react';

export const DisarmedAlarmIcon = (props: SVGProps<SVGSVGElement>) => {
	const color = props.color ?? '#FF0000';
	return (
		<svg width='17' height='20' viewBox='0 0 17 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M1.5 4L8.5 1L15.5 4V10V10C15.5 13.0919 13.8433 15.9467 11.1588 17.4807L8.5 19L5.84122 17.4807C3.15672 15.9467 1.5 13.0919 1.5 10V10V4Z'
				stroke={color}
				strokeWidth='1.38'
				strokeLinejoin='round'
			/>
			<path d='M5.5 13L11.5 7' stroke={color} strokeWidth='1.38' strokeLinecap='round' strokeLinejoin='round' />
			<path d='M5.5 7L11.5 13' stroke={color} strokeWidth='1.38' strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	);
};
